export const FRONTEND_VERSION = 3012;
